export { default as Img200 } from './processed/200/Predator-The.jpg';
export { default as Img400 } from './processed/400/Predator-The.jpg';
export { default as Imgthumb } from './processed/thumb/Predator-The.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Predator-The.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Predator-The.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      4,
      240,
      249
    ],
    "_population": 1864,
    "_hsl": [
      0.5061224489795918,
      0.968379446640316,
      0.49607843137254903
    ]
  },
  "LightVibrant": {
    "_rgb": [
      60,
      205,
      244
    ],
    "_population": 12,
    "_hsl": [
      0.5353260869565218,
      0.893203883495146,
      0.596078431372549
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      4,
      17,
      142
    ],
    "_population": 2207,
    "_hsl": [
      0.6509661835748792,
      0.945205479452055,
      0.28627450980392155
    ]
  },
  "Muted": {
    "_rgb": [
      87,
      73,
      154
    ],
    "_population": 17,
    "_hsl": [
      0.6954732510288065,
      0.3568281938325991,
      0.44509803921568625
    ]
  },
  "LightMuted": {
    "_rgb": [
      209,
      209,
      210
    ],
    "_population": 1987,
    "_hsl": [
      0.6666666666666666,
      0.010989010989010948,
      0.8215686274509804
    ]
  },
  "DarkMuted": {
    "_rgb": [
      70,
      66,
      93
    ],
    "_population": 26,
    "_hsl": [
      0.691358024691358,
      0.16981132075471692,
      0.31176470588235294
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Predator-The.js